<template>
  <div>
    <v-radio-group row v-model="form.type">
      <v-radio value="global" label="Global Default Value"></v-radio>
      <v-radio
        value="service"
        label="Service Specific Default Values"
      ></v-radio>
    </v-radio-group>
    <template-input
      v-if="form.type == 'global'"
      :item="field"
      :hide="true"
      label="Global"
      :form="{}"
      :isClearable="true"
      :isDense="true"
      :isRequired="false"
      v-model="form.global"
      @input="onInput"
    >
    </template-input>

    <template v-else>
      <v-row>
        <v-col v-for="(item, i) in templates" :key="i" cols="6" class="pt-0">
          <template-input
            :item="field"
            :hide="true"
            :isClearable="true"
            :label="item.name"
            :form="{}"
            :isDense="true"
            :isRequired="false"
            v-model="form.service[item.id]"
            @input="onInput"
          >
          </template-input>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import TemplateInput from "../../customers/create/TemplateInput.vue";
export default {
  props: {
    value: {},
    field: {},
    type: {
      type: String,
      default: "global"
    }
  },
  components: {
    TemplateInput
  },
  data() {
    return {
      form: {
        type: "global",
        global: "",
        service: {}
      }
    };
  },
  computed: {
    templates() {
      return this.$store.getters.templates.filter(item => {
        let isCustomer = item.type == 0;
        let isService = true;
        if (this.type == "service" && typeof this.field.services == "object") {
          isService = this.field.services.indexOf(item.id) != -1;
        }
        return isCustomer && isService;
      });
    }
  },
  methods: {
    onInput() {
      if (typeof this.form.service != "object") this.form.service = {};
      if (this.form.type == undefined) this.form.type = "global";
      if (this.form.global == undefined) this.form.global = "";
      
      // preventing passing undefined value for default service field 
      const defaultFormKeys = Object.keys(this.form?.service);
      defaultFormKeys.forEach(key =>
        this.form.service[key] = this.form.service[key] == undefined ? '' : this.form.service[key] 
      );

      this.$emit("input", this.form);
    }
  },
  beforeMount() {
    if (typeof this.value == "object") {
      this.form = this.value;
      if (typeof this.form.service != "object") this.form.service = {};
    }
  }
};
</script>

<style></style>
